module.exports = __webpack_public_path__ + "static/media/sel_16_264.c0748e27.mp4";